export const getRowsPerPageFromLocalStorage = (tableId?: string) => {
  const rowsPerPageFromStorage = localStorage.getItem(`${tableId}-rowsPerPage`);
  if (rowsPerPageFromStorage) {
    return JSON.parse(rowsPerPageFromStorage);
  }
  return undefined;
};

export const saveRowsPerPageToLocalStorage = (
  rowsPerPage?: number,
  tableId?: string
): void => {
  if (rowsPerPage && tableId) {
    localStorage.setItem(`${tableId}-rowsPerPage`, JSON.stringify(rowsPerPage));
  }
};
